export default function urlBuilder(to: string[]) {
	return `${to.join('/')}`
}
